import Axios from 'axios'

export default {
  state: {
    order: null,
    orders: []
  },
  getters: {
    ORDER: state => state.order
  },
  mutations: {
    ADD_ORDER (state, payload) {
      state.orders.push( payload )
    },
    SET_ORDER ( state, order ) {
      state.order = order;
    },
  },
  actions: {
    ADD_ORDER: async ( context, params ) => {
      let { data } = await Axios.post( '/orders', params );
      context.commit('ADD_ORDER', typeof(data.result) != 'undefined'? data.result: data);
      return typeof(data.result) != 'undefined'? data.result: data;
    },
    UPDATE_ORDER ( { commit }, order ) {
      commit( 'SET_ORDER', order );
    },
    GET_ORDER: async ( context, orderId ) => {
      context.commit('SET_ORDER', false);
      let { data } = await Axios.get( '/orders/' + orderId )
      context.commit('SET_ORDER', typeof(data.result) != 'undefined'? data.result: data);
      return typeof(data.result) != 'undefined'? data.result: data;
    }
  },
}
